import { createTheme } from "@mui/material";

const theme = createTheme({
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "1rem",
          boxShadow:
            "0px 2px 4px rgba(0, 0, 0, 0.4), 0px 7px 13px -3px rgba(0, 0, 0, 0.3), inset 0px -3px 0px rgba(0, 0, 0, 0.2);",
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          backgroundColor: "transparent",
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {},
        content: {},
        contentGutters: {},
      },
    },
  },
});

export default theme;
